module.exports = __webpack_public_path__ + "img/timer-icon.bf23eefb.svg";